<template>
    <!-- Modal -->
    <div class="modal fade" id="depositViaATM" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">NẠP QUA ATM <span v-if="settings.discount_atm > 0">TẶNG {{ settings.discount_atm }}%</span></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
<!--                    <p> Bạn sẽ được cộng thêm <b class="text-danger">{{ settings.discount_atm }}%</b> giá trị giao-->
<!--                        dịch-->
<!--                        <br>-->
<!--                        (VD: <b class="text-danger">Nạp 100,000đ</b> sẽ nhận được <b-->
<!--                            class="text-danger">{{ Helper.formatMoney((100000/100) * (100 + settings.discount_atm)) }}-->
<!--                            đ</b> )-->
<!--                    </p>-->
                    <div class="card">
                        <div class="card-body">
                            <b>CHỦ TK : NGUYỄN ĐỨC HIỆP</b>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">
                                STK: <b class="text-danger">19030500042688</b>
                                <br>
                                Ngân hàng:  <b class="text-danger">Techcombank</b>
                                <br>
                                Chi nhánh: <b class="text-danger">Đông Đô Hà Nội</b>
                            </li>
                            <li class="list-group-item">
                                STK: <b class="text-success">0011004130073</b>
                                <br>
                                Ngân hàng:  <b class="text-success">Vietcombank</b>
                                <br>
                                Chi nhánh: <b class="text-success">Ba Đình Hà Nội</b>
                            </li>
                            <li class="list-group-item">
                                STK: <b class="text-info">103006769622</b>
                                <br>
                                Ngân hàng:  <b class="text-info">Vietinbank</b>
                                <br>
                                Chi nhánh: <b class="text-info">Hà nội</b>
                            </li>
                            <li class="list-group-item">
                                STK: <b class="text-danger">1303206301280</b>
                                <br>
                                Ngân hàng:  <b class="text-danger">Agribank</b>
                                <br>
                                Chi nhánh: <b class="text-danger">Hà thành</b>
                            </li>
                            <li class="list-group-item">
                                STK: <b class="text-primary">21110000636305</b>
                                <br>
                                Ngân hàng:  <b class="text-primary">BIDV</b>
                                <br>
                                Chi nhánh: <b class="text-primary">Hà Nội</b>
                            </li>
                        </ul>
                    </div>

                    <br>

                    <p>
                        Nội dung ghi rõ<sup class="text-warning">(*)</sup>: <strong class="text-danger" id="napmomo">NAP{{ website.id }} +
                        <a :href="route('userfe', { domain : website.domain })">{ID tài khoản của bạn}</a></strong>
                    </p>

                    <p>
                        <b class="text-danger">Sau khi gửi tiền thành công, vui lòng chụp hình ảnh giao dịch và gửi qua <a target="_blank" :href="'https://fb.com/' + website.facebook">Fanpage Facebook</a>.</b>
                    </p>

                    <p class="text-small">
                        <b class="text-warning">Lưu ý</b>: Vui lòng kiểm tra lại thông tin trước khi
                        chuyển khoản, nội dung chuyển khoản phải <span class="text-warning">chính xác</span>.
                        Nếu bạn làm sai sẽ không được cộng tiền.
                    </p>

                    <p class="text-small">
                        Trong trường hợp bạn <span class="text-danger">chắc chắn làm đúng</span>
                        mà <span class="text-warning">không nhận được tiền sau 15p</span> vui lòng nhắn tin cho chúng tôi
                        để được hỗ trợ!
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Đóng</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                Type: Object,
                default() {
                    return {};
                }
            },
            website: {
                Type: Object,
                default() {
                    return {};
                }
            },
            settings: {
                Type: Object,
                default() {
                    return {};
                }
            }
        },
        data() {
            return {}
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
